import dayjs from "dayjs";

type Primitive = string | number | boolean | null | undefined;

type WithKycDetails<T> = T & { kycDetails: Record<string, Primitive> };

const isKycValueObject = (val: unknown): val is { value: Primitive | Date; label?: string } =>
  typeof val === "object" && val !== null && "value" in val;

export const transformKycFields = <T extends Record<string, unknown>>(
  input: T
): WithKycDetails<Omit<T, keyof T & string>> => {
  const baseData: Record<string, unknown> = {};
  const kycDetails: Record<string, Primitive> = {};

  for (const [key, value] of Object.entries(input)) {
    if (key.startsWith("kyc-")) {
      const fieldName = key.slice(4);

      const rawValue = isKycValueObject(value) ? value.value : (value as Primitive | Date);
      const isDate = fieldName.toLowerCase().includes("date");

      if (isDate && (typeof rawValue === "string" || typeof rawValue === "number" || rawValue instanceof Date)) {
        kycDetails[fieldName] = dayjs(rawValue).format("YYYY-MM-DD");
      } else {
        kycDetails[fieldName] = rawValue as Primitive;
      }
    } else {
      baseData[key] = value;
    }
  }

  return { ...(baseData as T), kycDetails };
};
